// extracted by mini-css-extract-plugin
export default {"fieldSet":"AddDiscountModal_fieldSet__8jUm5","flex":"AddDiscountModal_flex__Zm7Pu"};